import React, { useState } from "react";
import ProductType, {
    ClientProductTypes
} from "../../../common/interfaces/enums/ProductType";
import { Severity } from "../../../common/interfaces/enums/Severity";
import Alert from "../../../common/components/Alert/Alert";
import CallbackModal from "../../../common/components/Modals/CallbackModal/CallbackModal";
import useLightwindow from "../../../common/hooks/useLightwindow";

// styles
import cx from "classnames";

interface IProductWarningsProps {
    currentProduct: ClientProductTypes;
    className?: string;
}

const ProductWarnings: React.FC<IProductWarningsProps> = ({
    currentProduct,
    className
}) => {
    const [isOpenCallback, setIsOpenCallback] = useState(false);

    const { openContactModal } = useLightwindow();

    const getWarning = (): React.ReactNode => {
         if (currentProduct === ProductType.Health) {
            return (
                <div>
                    <CallbackModal
                        isOpen={isOpenCallback}
                        onClose={() => setIsOpenCallback(false)}
                    />
                    <Alert severity={Severity.Info}>
                        <p>
                            Do you want cover for pre-existing conditions?{" "}
                            <a onClick={() => setIsOpenCallback(!isOpenCallback)}>
                                {"Request a callback"}
                            </a>{" "}
                            or <a onClick={openContactModal}>{"contact us"}</a> to discuss
                            your options today.
                        </p>
                    </Alert>
                </div>
            );
        }
        return null;
    };

    const warning = getWarning();

    if (!warning) return null;

    return (
        <div
            className={cx({
                [className]: !!className
            })}>
            {warning}
        </div>
    );
};

export default ProductWarnings;
